export interface AutoFitColumnsOptions {
	minWidth?: number;
	maxWidth?: number;
	padding?: number;
	currencyColumns?: number[];
}

const CURRENCY_EXTRA_PADDING = 4;

/**
 * Auto-fits worksheet column widths based on the row data used to build the sheet.
 *
 * @params : `ws` : XLSX worksheet to size (mutated in place via `!cols`)
 * @params : `rows` : the same `any[][]` array passed to `XLSX.utils.aoa_to_sheet`
 * @params : `options.currencyColumns` : column indices that will be rendered with a currency
 *           number format (e.g. via a separate `formatCell` call) but whose raw row value is
 *           not yet `$`-prefixed — these get extra padding so the eventual `$#,##0.00` display
 *           isn't underestimated
 */
export function autoFitColumns(ws: any, rows: any[][], options: AutoFitColumnsOptions = {}): void {
	const minWidth = options.minWidth ?? 8;
	const maxWidth = options.maxWidth ?? 40;
	const padding = options.padding ?? 2;
	const currencyColumns = options.currencyColumns ?? [];

	const colCount = rows.reduce((max, row) => Math.max(max, row.length), 0);
	const widths = new Array(colCount).fill(0);

	rows.forEach(row => {
		row.forEach((cell, c) => {
			if (cell === null || cell === undefined || cell === '') { return; }
			const text = String(cell);
			let len = text.length;
			if (currencyColumns.includes(c) && !text.startsWith('$')) {
				len += CURRENCY_EXTRA_PADDING;
			}
			if (len > widths[c]) { widths[c] = len; }
		});
	});

	ws['!cols'] = widths.map(w => ({ wch: Math.min(Math.max(w + padding, minWidth), maxWidth) }));
}
